"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.EntityActivityDetails = exports.EntityActivityDetailsDefaultProps = void 0;
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importStar(require("styled-components"));
var theme_1 = require("@shapeable/theme");
var content_1 = require("../elements/content");
var image_bubble_1 = require("../elements/image-bubble");
var entity_link_1 = require("./entity-link");
exports.EntityActivityDetailsDefaultProps = {
  variant: 'half',
  showTitleLink: false,
  external: false
};
// -------- Styles -------->
var ContainerStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    border-top: 1px solid ", ";\n    padding-top: ", ";\n    display: flex;\n    flex-direction: column;\n  "], ["\n    border-top: 1px solid ", ";\n    padding-top: ", ";\n    display: flex;\n    flex-direction: column;\n  "])), theme_1.theme.COLOR('line-subtle'), theme_1.theme.UNIT(5)),
  tablet: (0, styled_components_1.css)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    flex-direction: row;\n  "], ["\n    flex-direction: row;\n  "])))
});
var DescriptionStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    line-height: 1.35em;\n  "], ["\n    line-height: 1.35em;\n  "])))
});
var DescriptionContainerStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    padding-right: ", ";\n    padding-bottom: ", ";\n  "], ["\n    padding-right: ", ";\n    padding-bottom: ", ";\n  "])), theme_1.theme.UNIT(6), theme_1.theme.UNIT(5)),
  tablet: (0, styled_components_1.css)(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n    padding-right: ", ";\n\n    ", "\n\n    ", "\n\n    ", "\n\n  "], ["\n    padding-right: ", ";\n\n    ", "\n\n    ", "\n\n    ", "\n\n  "])), theme_1.theme.UNIT(6), function (props) {
    return props.variant === 'half' && (0, styled_components_1.css)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n      width: 60%;\n      width: 70%;\n    "], ["\n      width: 60%;\n      width: 70%;\n    "])));
  }, function (props) {
    return props.variant === 'bubble' && (0, styled_components_1.css)(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n      width: 75%;\n      width: 85%;\n    "], ["\n      width: 75%;\n      width: 85%;\n    "])));
  }, function (props) {
    return !props.hasImage && (0, styled_components_1.css)(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n      width: 100%;\n    "], ["\n      width: 100%;\n    "])));
  })
});
var ImageContainerStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "]))),
  tablet: (0, styled_components_1.css)(templateObject_12 || (templateObject_12 = __makeTemplateObject(["\n    ", "\n    \n    ", "\n  "], ["\n    ", "\n    \n    ", "\n  "])), function (props) {
    return props.variant === 'half' && (0, styled_components_1.css)(templateObject_10 || (templateObject_10 = __makeTemplateObject(["\n      width: 40%;\n      width: 30%;\n    "], ["\n      width: 40%;\n      width: 30%;\n    "])));
  }, function (props) {
    return props.variant === 'bubble' && (0, styled_components_1.css)(templateObject_11 || (templateObject_11 = __makeTemplateObject(["\n      width: 25%;\n      width: 15%;\n    "], ["\n      width: 25%;\n      width: 15%;\n    "])));
  }),
  last: (0, styled_components_1.css)(templateObject_13 || (templateObject_13 = __makeTemplateObject(["\n  "], ["\n  "])))
});
var ImageStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_14 || (templateObject_14 = __makeTemplateObject(["\n    width: 100%;\n    height: 100%;\n    object-fit: cover;\n  "], ["\n    width: 100%;\n    height: 100%;\n    object-fit: cover;\n  "]))),
  landscape: (0, styled_components_1.css)(templateObject_16 || (templateObject_16 = __makeTemplateObject(["\n\n    ", "\n  "], ["\n\n    ", "\n  "])), function (props) {
    return props.isLogo && (0, styled_components_1.css)(templateObject_15 || (templateObject_15 = __makeTemplateObject(["\n      object-fit: contain;\n    "], ["\n      object-fit: contain;\n    "])));
  })
});
var ImageBubbleStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_17 || (templateObject_17 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
});
var TitleStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_18 || (templateObject_18 = __makeTemplateObject(["\n    font-weight: 500;\n    line-height: 1.35em;\n    margin-bottom: ", ";\n  "], ["\n    font-weight: 500;\n    line-height: 1.35em;\n    margin-bottom: ", ";\n  "])), theme_1.theme.UNIT(3))
});
var ImageEntityLinkStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_19 || (templateObject_19 = __makeTemplateObject(["\n    display: block;\n  "], ["\n    display: block;\n  "])))
});
var ImageConstrainStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_20 || (templateObject_20 = __makeTemplateObject(["\n    width: 100%;\n    height: 160px;\n  "], ["\n    width: 100%;\n    height: 160px;\n  "]))),
  tablet: (0, styled_components_1.css)(templateObject_21 || (templateObject_21 = __makeTemplateObject(["\n  "], ["\n  "])))
});
// -------- Components -------->
var My = {
  Container: styled_components_1.default.div(templateObject_22 || (templateObject_22 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  DescriptionContainer: styled_components_1.default.div(templateObject_23 || (templateObject_23 = __makeTemplateObject(["", ""], ["", ""])), DescriptionContainerStyles),
  EntityLink: (0, styled_components_1.default)(entity_link_1.EntityLink)(templateObject_24 || (templateObject_24 = __makeTemplateObject(["", ""], ["", ""])), TitleStyles),
  Description: (0, styled_components_1.default)(content_1.Content)(templateObject_25 || (templateObject_25 = __makeTemplateObject(["", ""], ["", ""])), DescriptionStyles),
  ImageEntityLink: (0, styled_components_1.default)(entity_link_1.EntityLink)(templateObject_26 || (templateObject_26 = __makeTemplateObject(["", ""], ["", ""])), ImageEntityLinkStyles),
  ImageContainer: styled_components_1.default.div(templateObject_27 || (templateObject_27 = __makeTemplateObject(["", ""], ["", ""])), ImageContainerStyles),
  ImageConstrain: styled_components_1.default.div(templateObject_28 || (templateObject_28 = __makeTemplateObject(["", ""], ["", ""])), ImageConstrainStyles),
  Image: styled_components_1.default.img(templateObject_29 || (templateObject_29 = __makeTemplateObject(["", ""], ["", ""])), ImageStyles),
  ImageBubble: (0, styled_components_1.default)(image_bubble_1.ImageBubble)(templateObject_30 || (templateObject_30 = __makeTemplateObject(["", ""], ["", ""])), ImageBubbleStyles)
};
var EntityActivityDetails = function (props) {
  var className = props.className,
    entry = props.entry,
    definition = props.definition,
    t = props.t,
    children = props.children,
    variant = props.variant,
    showTitleLink = props.showTitleLink,
    external = props.external;
  var date = entry.date,
    action = entry.action,
    entity = entry.entity;
  var openGraph = entity && entity.openGraph;
  var description = openGraph && openGraph.description;
  var image = openGraph && openGraph.image;
  // TODO - address this with config
  var isLogo = entity.__typename === 'Organisation';
  var descriptionText = description && description.plainTruncated;
  var hasImage = !!image;
  var hasDescription = !!descriptionText;
  var targetProps = external ? entity_link_1.linkTargetPropsFromOpenGraph : entity_link_1.linkTargetPropsFromSlug;
  return react_1.default.createElement(My.Container, {
    variant: variant,
    hasImage: hasImage,
    hasDescription: hasDescription,
    className: className
  }, (descriptionText || showTitleLink) && react_1.default.createElement(My.DescriptionContainer, {
    hasImage: hasImage,
    variant: variant
  }, showTitleLink && react_1.default.createElement(My.EntityLink, {
    targetProps: targetProps,
    entity: entity
  }), react_1.default.createElement(My.Description, {
    variant: variant,
    hasImage: hasImage,
    verySmall: true,
    html: descriptionText
  })), image && (variant === 'bubble' ? react_1.default.createElement(My.ImageEntityLink, {
    targetProps: targetProps,
    entity: entity
  }, react_1.default.createElement(My.ImageBubble, {
    size: 100,
    image: image
  })) : react_1.default.createElement(My.ImageContainer, {
    variant: variant
  }, react_1.default.createElement(My.ImageEntityLink, {
    targetProps: targetProps,
    entity: entity
  }, react_1.default.createElement(My.ImageConstrain, null, react_1.default.createElement(My.Image, {
    isLogo: isLogo,
    src: image.url
  }))))));
};
exports.EntityActivityDetails = EntityActivityDetails;
// export const entityActivityDetailsBubble = () => (props: EntityPlatformActivityComponentProps) => <EntityActivityDetails {...props} variant="bubble" />;
// export const entityActivityDetailsWithLink = () => (props: EntityPlatformActivityComponentProps) => <EntityActivityDetails {...props} showTitleLink />;
// export const entityActivityDetailsWithExternalLink = () => (props: EntityPlatformActivityComponentProps) => <EntityActivityDetails {...props} external showTitleLink />;
exports.EntityActivityDetails.defaultProps = exports.EntityActivityDetailsDefaultProps;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12, templateObject_13, templateObject_14, templateObject_15, templateObject_16, templateObject_17, templateObject_18, templateObject_19, templateObject_20, templateObject_21, templateObject_22, templateObject_23, templateObject_24, templateObject_25, templateObject_26, templateObject_27, templateObject_28, templateObject_29, templateObject_30;